function getVar(name: string): string {
  name = `VITE_` + name
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const env = window[`eyecue_env` as any] as any

  return env ? env[name] : import.meta.env[name]
}

// [eyecue-codemap:VKhVZUxj3fK]
const EnvVars = {
  AIRBRAKE_PROJECT_ID: getVar(`AIRBRAKE_PROJECT_ID`),
  AIRBRAKE_PROJECT_KEY: getVar(`AIRBRAKE_PROJECT_KEY`),
  API_URL: import.meta.env.VITE_API_URL_OVERRIDE ?? getVar(`API_URL`),
  GOOGLE_MAPS_API_KEY: getVar(`GOOGLE_MAPS_API_KEY`),
  CYPRESS_ADMIN_JWT_KEY: getVar(`CYPRESS_ADMIN_JWT_KEY`),
  NODE_ENV: getVar(`NODE_ENV`),
  DISABLE_AIRBRAKE: true,
  NEARMAP_API_KEY: getVar(`NEARMAP_API_KEY`),
  POWUR_PLATFORM_URL: getVar(`POWUR_PLATFORM_URL`),
  VISION_URL: getVar(`VISION_URL`),
  VISION_API_KEY: getVar(`VISION_API_KEY`),
  ADMIN_PROPOSAL_CREATE_IS_ENABLED: getVar(`ADMIN_PROPOSAL_CREATE_IS_ENABLED`),
  // Read lazily so runtime-injected config is honored; anything but the
  // literal string "true" (including unset) disables the flag.
  get ADMIN_PRICING_HISTORY_ENABLED(): boolean {
    return getVar(`ADMIN_PRICING_HISTORY_ENABLED`) === `true`
  },
  get BATTERY_SAVINGS_ENABLED(): boolean {
    return getVar(`BATTERY_SAVINGS_ENABLED`) === `true`
  },
  // Hides the Versions tab in the Aurora Design drawer until Aurora Design
  // Versions are ready to release.
  get AURORA_DESIGN_VERSIONS_ENABLED(): boolean {
    return getVar(`AURORA_DESIGN_VERSIONS_ENABLED`) === `true`
  },
  // On in local dev so the fixture-backed page is reachable; deployed
  // environments stay off until the page reads real data.
  get SOLAR_PROPOSAL_V2_ENABLED(): boolean {
    return import.meta.env.DEV || getVar(`SOLAR_PROPOSAL_V2_ENABLED`) === `true`
  },
}

export default EnvVars
